import React from 'react'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import Route from '../../components/route/Route'
import Footer from '../../components/common/Footer'
export default function RoutePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <Route/>
            <Footer/>
        </>
    )
}